import { ShoppingBasket, Zap, BellRing } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const Card = ({ testid, icon: Icon, title, copy, stat, statLabel, className }) => (
  <div
    data-testid={testid}
    className={`group relative overflow-hidden rounded-3xl bg-mist p-10 transition-transform duration-500 ease-out hover:-translate-y-2 lg:p-12 ${className}`}
  >
    <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full bg-fresh/10 transition-transform duration-700 group-hover:scale-[1.8]" />
    <span className="relative inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-forest text-bone transition-colors duration-500 group-hover:bg-fresh">
      <Icon className="h-6 w-6" />
    </span>
    <h3 className="relative mt-8 font-syne text-2xl font-bold tracking-tight text-forest lg:text-3xl">
      {title}
    </h3>
    <p className="relative mt-4 max-w-md text-sm leading-relaxed text-forest/60 md:text-base">
      {copy}
    </p>
    {stat && (
      <p className="relative mt-8">
        <span className="font-syne text-5xl font-extrabold tracking-tighter text-forest lg:text-6xl">
          {stat}
        </span>
        <span className="ml-3 text-xs font-bold uppercase tracking-[0.2em] text-fresh">
          {statLabel}
        </span>
      </p>
    )}
  </div>
);

export const Benefits = () => (
  <section
    id="standard"
    className="mx-auto max-w-[1400px] px-6 py-24 md:px-12 lg:py-36"
  >
    <Reveal className="mb-16 max-w-2xl">
      <Chapter number="02" label="The Freshly Standard" />
      <h2 className="mt-6 font-syne text-4xl font-extrabold leading-[1.02] tracking-tighter text-forest sm:text-5xl lg:text-6xl">
        Built for people
        <br />
        who <span className="text-fresh">don&apos;t wait.</span>
      </h2>
    </Reveal>

    <div data-testid="benefits-grid" className="grid grid-cols-1 gap-6 lg:grid-cols-12">
      <Reveal className="lg:col-span-7" delay={0.1}>
        <Card
          testid="benefit-shop-smarter"
          icon={ShoppingBasket}
          title="Shop Smarter"
          copy="Expert pickers choose your freshest produce — the avocados you'd squeeze yourself, the berries you'd reach past for. Every item hand-checked against our freshness standard."
        />
      </Reveal>
      <Reveal className="lg:col-span-5" delay={0.2}>
        <Card
          testid="benefit-real-time"
          icon={Zap}
          title="Real-Time Speed"
          copy="Optimized routes built for Calgary's grid, from the Beltline to Brentwood."
          stat="20–30"
          statLabel="minute delivery"
        />
      </Reveal>
      <Reveal className="lg:col-span-12" delay={0.3}>
        <Card
          testid="benefit-stress-free"
          icon={BellRing}
          title="Stress-Free"
          copy="Real-time updates from the moment your picker grabs the first item to the knock at your door. Live tracking, honest ETAs, instant substitutions — you're never in the dark."
          className="lg:flex lg:items-center lg:gap-12"
        />
      </Reveal>
    </div>
  </section>
);
